import { render, staticRenderFns } from "./PopupFavoriteDislikedMeal.vue?vue&type=template&id=542e922e"
import script from "./PopupFavoriteDislikedMeal.vue?vue&type=script&lang=js"
export * from "./PopupFavoriteDislikedMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports